import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import { useTheme } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const subMenu = [
  { id: 1, label: 'Portfolios', url: 'portfolio' },
  { id: 2, label: 'Fondos', url: 'products' },
];

export const useMenuHandlerMobile = () => {
  const [value, setValue] = useState('dashboard');
  const [prevValue, setPrevValue] = useState('dashboard');
  const [openMovil, setOpenMovil] = useState(false);
  const [open, setOpen] = useState(false);
  const [openReferidos, setOpenReferidos] = useState(false);
  const [copyText, setCopyText] = useState('Copiar mi link para referir');
  const { user } = useSelector(state => state.auth);
  const navigate = useNavigate();
  const [access, setAccess] = useState(false);
  const [accessWallet, setAccessWallet] = useState(false);
  const [activeNavbar, setActiveNavbar] = useState(1);
  const [userNotOB, setUserNotOB] = useState(false);
  const touchStartY = useRef(null);

  const theme = useTheme();

  const handleChange = newValue => {
    setValue(newValue);
  };

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleOpenMovil = open => event => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    if (open) {
      setPrevValue(value);
      setValue('menu');
      setOpenMovil(true);
    } else {
      setValue(prevValue);
      setOpenMovil(false);
    }
  };

  const handleNavigateDashboard = () => {
    navigate(access ? '/myprofilerisk' : 'profile');
    setValue('dashboard');
  };

  const handleNavigateWallet = () => {
    navigate(accessWallet ? 'wallet' : 'completeregistration');
    setValue('caja');
  };

  const handleNavigateTransactions = val => {
    const path = userNotOB ? '/mytransactions' : 'completeregistration';
    navigate(path);
    setActiveNavbar(val);
    setValue('Transacciones');
  };

  const handleNavigateSubMenu = url => {
    navigate(url);
    setValue('menu');
    setOpenMovil(false);
  };

  const handleClickHome = () => {
    navigate(access ? '/myprofilerisk' : 'profile');
  };

  const handleNavigateMyAccount = url => {
    navigate(url);
    setOpenMovil(false);
    setOpenReferidos(false);
  };

  const handleTouchStart = e => {
    touchStartY.current = e.touches[0].clientY;
  };

  const handleTouchEnd = e => {
    const touchEndY = e.changedTouches[0].clientY;
    const distance = touchStartY.current - touchEndY;

    if (distance > 50) {
      setOpenMovil(false);
      setValue(prevValue);
    }
  };

  const myDataUrl = userNotOB ? '/myaccount' : '/completeregistration';

  const myAccountBtn = {
    name: 'Mi cuenta',
    subMenu: [
      { id: 1, btnNameSub: 'Mi perfil de riesgo', url: 'profileselect' },
      {
        id: 2,
        btnNameSub: 'Mis objetivos e intereses',
        url: 'myobjectivesinterests',
      },
      { id: 3, btnNameSub: 'Mis datos', url: myDataUrl },
      { id: 4, btnNameSub: 'Cambiar contraseña', url: 'changepassword' },
    ],
  };

  const contentMenu = [
    {
      id: 1,
      label: 'Inicio',
      value: 'dashboard',
      icon: <HomeOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: '28px' }} />,
      action: handleNavigateDashboard,
    },
    {
      id: 2,
      label: 'Caja',
      value: 'caja',
      icon: (
        <AccountBalanceWalletOutlinedIcon
          sx={{ color: theme.palette.primary.main, fontSize: '28px' }}
        />
      ),
      action: handleNavigateWallet,
    },
    {
      id: 3,
      label: 'Transacciones',
      value: 'Transacciones',
      icon: <ReceiptOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: '28px' }} />,
      action: handleNavigateTransactions,
    },
    {
      id: 4,
      label: 'Menu',
      value: 'menu',
      icon: <MenuOutlinedIcon sx={{ color: theme.palette.primary.main, fontSize: '28px' }} />,
      action: handleOpenMovil(true),
    },
  ];

  useEffect(() => {
    if (
      user?.['custom:checkid-sign-doc'] &&
      user['custom:checkid-sign-doc'] === 'signature_success'
    ) {
      setAccessWallet(true);
      setUserNotOB(true);
    } else {
      setUserNotOB(false);
    }
  }, [user]);

  useEffect(() => {
    if (user?.['custom:profile']) {
      setAccess(true);
    }
  }, [user]);

  useEffect(() => {
    setOpenMovil(false);
  }, [navigate]);

  useEffect(() => {
    setOpenMovil(false);
    setOpen(false);
    setOpenReferidos(false);
  }, []);

  useEffect(() => {
    if (!openMovil && value !== 'menu') {
      setValue(prevValue);
    }
  }, [openMovil]);

  return {
    subMenu,
    contentMenu,
    myAccountBtn,
    value,
    openMovil,
    open,
    openReferidos,
    copyText,
    user,
    navigate,
    access,
    accessWallet,
    activeNavbar,
    userNotOB,
    touchStartY,
    setOpen,
    setOpenReferidos,
    handleChange,
    handleOpen,
    handleOpenMovil,
    handleNavigateDashboard,
    handleNavigateWallet,
    handleNavigateTransactions,
    handleNavigateSubMenu,
    handleClickHome,
    handleNavigateMyAccount,
    handleTouchStart,
    handleTouchEnd,
  };
};
